import { useParams } from 'react-router-dom';
import LetterNoteModal from './LetterNoteModal';
import LetterClientModal from './LetterClientModal';
import React, { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';
import LetterTaskModal, { LetterTaskForm } from './UserMail/LetterTaskModal';
import { createLetterTask, getLetterDetails } from '../../../../../Features/letterBox/api/letterBox.api';
import { Card } from 'reactstrap';
import { useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import UserMail from './UserMail';
import { RootState } from '../../../../../ReduxToolkit/Store';
import MailBody1 from './MailBody1';
import { LetterDetailResponse } from '../../../../../Features/letterBox/api/types';
import { useReadNotificationsForPath } from '../../../../../Features/notifications/hooks/useNotifications';

export default function EmailRead({ detail, isLoadingDetail }: { detail: LetterDetailResponse | null; isLoadingDetail: boolean }) {
    const { emailId } = useParams<{ emailId: string }>();
    const { interviewEmail } = useSelector((state: RootState) => state.email);
    const [taskOpen, setTaskOpen] = useState(false);
    const [noteOpen, setNoteOpen] = useState(false);
    const [clientOpen, setClientOpen] = useState(false);
    const [createdNotes, setCreatedNotes] = useState<Record<number, { noteID: number; progettoID: number }>>({});
    const noteID = detail ? (createdNotes[detail.data.ID]?.noteID || detail.note || 0) : 0;
    const progettoID = detail ? (createdNotes[detail.data.ID]?.progettoID ?? detail.data.progettoID) : undefined;
    const attivitaID = detail ? (createdNotes[detail.data.ID]?.noteID || detail.data.attivitaID || noteID) : 0;
    const taskHref = progettoID && progettoID > 0 && attivitaID > 0 ? `${process.env.PUBLIC_URL || ''}/progetti/${progettoID}/${attivitaID}` : undefined;
    useEffect(() => { setNoteOpen(false); setClientOpen(false); }, [detail?.data.ID]);
    const queryClient = useQueryClient();
    // Aggiorna le notifiche solo dopo aver ricevuto il dettaglio email.
    useReadNotificationsForPath('/gestione-email/' + emailId, Boolean(emailId && detail) && !isLoadingDetail);
    const addTask = async (values: LetterTaskForm) => {
        const endpoint = 'progetti/nuova_attivita';
        if (!endpoint) throw new Error('Endpoint di creazione task non configurato.');
        if (!detail || isLoadingDetail) throw new Error('Attendi il caricamento del dettaglio email.');
        const result = await createLetterTask(endpoint, { ...values, letterBoxID: detail.data.ID, ticketID: detail.data.ticketID ?? null });
        queryClient.invalidateQueries({ queryKey: ['task-list'] });
        toast.success('Task aggiunto.');
        let newNoteID = result.note || 0;
        if (!newNoteID) {
            try {
                const refreshed = await getLetterDetails(detail.data.ID);
                newNoteID = refreshed.note || 0;
            } catch {
                toast.error('Task creato. Impossibile aggiornare le note: riapri il dettaglio email.');
            }
        }
        if (newNoteID > 0) setCreatedNotes(current => ({ ...current, [detail.data.ID]: { noteID: newNoteID, progettoID: values.progettoID } }));
    };
    const contentRef = useRef<HTMLDivElement>(null);
    const handlePrint = useReactToPrint({ contentRef });


    return (
        <Card className={`email-body email-read ${interviewEmail ? "show" : "hide"}`}>
            <MailBody1 onAddTask={() => setTaskOpen(true)} taskDisabled={!detail || isLoadingDetail} hasTask={noteID > 0} taskHref={taskHref} onAddNote={() => setNoteOpen(true)} noteDisabled={!detail || isLoadingDetail || noteID <= 0} onAddClient={() => setClientOpen(true)} />
            {clientOpen && detail && !isLoadingDetail && <LetterClientModal key={detail.data.ID} email={detail.data.from_email} onClose={() => setClientOpen(false)} />}
            {taskOpen && detail && <LetterTaskModal key={detail.data.ID} subject={detail.data.subject} onClose={() => setTaskOpen(false)} onSubmit={addTask} />}
            {noteOpen && detail && !isLoadingDetail && noteID > 0 && <LetterNoteModal key={`${detail.data.ID}-${noteID}`} noteID={noteID} progettoID={progettoID} emailID={Number(emailId)} onClose={() => setNoteOpen(false)} />}
            <div className="mail-body-wrapper" ref={contentRef}>
                <UserMail handlePrint={handlePrint} detail={detail} isLoadingDetail={isLoadingDetail} />
            </div>
        </Card>
    )
}
